import gql from 'graphql-tag';

export default gql`
  mutation adminCreateAllocationEntry($input: AdminAllocationEntryInput!) {
    adminCreateAllocationEntry(input: $input) {
      id
    }
  }
`;
